"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var AbstractComponent_1 = __importDefault(require("./AbstractComponent"));
var constants_1 = require("../data/constants");
var constantsClasses_1 = require("../data/constantsClasses");
var constants_2 = require("../../../../../ww_jobs/Resources/Private/app/data/constants");
var FormSelectMultiple = /** @class */ (function (_super) {
    __extends(FormSelectMultiple, _super);
    function FormSelectMultiple() {
        var _this = _super.call(this, constants_1.DATA_FORM_SELECT_MULTIPLE) || this;
        _this.selectArrays = [];
        if (!_this.getElement())
            return _this;
        _this.multiSelect = document.querySelectorAll("[".concat(constants_1.DATA_FORM_SELECT_MULTIPLE, "]"));
        _this.clearFilter = document.querySelectorAll("[".concat(constants_2.DATA_FILTER_CLEAR, "]"));
        _this.initEventListeners();
        return _this;
    }
    FormSelectMultiple.prototype.initEventListeners = function () {
        var _this = this;
        this.multiSelect.forEach(function (select, index) {
            var selectedOptions = [];
            _this.selectArrays.push(selectedOptions);
            var span = select.querySelector("[".concat(constants_1.DATA_FORM_SELECT_MULTIPLE_RESULTS, "]"));
            var selectOptions = select.querySelectorAll("[".concat(constants_1.DATA_FORM_SELECT_MULTIPLE_OPTION, "]"));
            span.addEventListener('click', function () {
                _this.toggleOptionList(select);
            });
            selectOptions.forEach(function (option) {
                option.addEventListener('click', function () {
                    _this.toggleSelectedOptions(option, _this.selectArrays[index]);
                });
            });
        });
        document.addEventListener('click', function (event) {
            _this.multiSelect.forEach(function (select) {
                _this.checkOutsideClick(event, select);
            });
        });
        this.clearFilter.forEach(function (button) {
            button.addEventListener('click', function () {
                _this.clearAllOptions();
            });
        });
    };
    /**
     * Toggle the multiselect dropdown
     * @param select
     * @private
     */
    FormSelectMultiple.prototype.toggleOptionList = function (select) {
        if (!select.classList.contains(constantsClasses_1.CLASS_OPEN)) {
            this.openOptionList(select);
        }
        else {
            this.closeOptionList(select);
        }
    };
    /**
     * Show the multiselect dropdown
     * @param select
     * @private
     */
    FormSelectMultiple.prototype.openOptionList = function (select) {
        select.classList.add(constantsClasses_1.CLASS_OPEN);
    };
    /**
     * Hide the multiselect dropdown
     * @param select
     * @private
     */
    FormSelectMultiple.prototype.closeOptionList = function (select) {
        select.classList.remove(constantsClasses_1.CLASS_OPEN);
    };
    /**
     * Toggle the options
     * @param option
     * @param selectedOptions
     * @private
     */
    FormSelectMultiple.prototype.toggleSelectedOptions = function (option, selectedOptions) {
        var checkBox = option.querySelector('.form-check');
        var optionValue = option.querySelector('span').innerHTML;
        if (checkBox.checked && !selectedOptions.includes(option.querySelector('span').innerHTML)) {
            this.addSelectedOption(optionValue, option.parentElement.previousElementSibling, selectedOptions);
        }
        else if (!checkBox.checked && selectedOptions.includes(option.querySelector('span').innerHTML)) {
            this.removeSelectedOption(optionValue, option.parentElement.previousElementSibling, selectedOptions);
        }
    };
    /**
     *  Add options to selectedOptions array
     *  @param optionValue
     *  @param results
     *  @param selectedOptions
     *  @private
     */
    FormSelectMultiple.prototype.addSelectedOption = function (optionValue, results, selectedOptions) {
        selectedOptions.push(optionValue);
        this.showSelectedOptions(selectedOptions, results);
    };
    /**
     *  Remove options to selectedOptions array
     *  @param optionValue
     *  @param results
     *  @param selectedOptions
     *  @private
     */
    FormSelectMultiple.prototype.removeSelectedOption = function (optionValue, results, selectedOptions) {
        var index = selectedOptions.indexOf(optionValue);
        if (index > -1) {
            selectedOptions.splice(index, 1);
            this.showSelectedOptions(selectedOptions, results);
        }
        else {
            this.showSelectedOptions(selectedOptions, results);
        }
    };
    /**
     * Output the selected values to frontend
     * @param selectedOptions
     * @param results
     * @private
     */
    FormSelectMultiple.prototype.showSelectedOptions = function (selectedOptions, results) {
        if (selectedOptions.length > 0) {
            results.innerHTML = selectedOptions.join(', ');
            results.classList.remove('text-white');
            results.parentElement.classList.add('is-filled');
        }
        else {
            results.innerHTML = 'Value';
            results.classList.add('text-white');
            results.parentElement.classList.remove('is-filled');
        }
    };
    /**
     * Hide the multiselect dropdown if clicked outside element
     * @param event
     * @param select
     * @private
     */
    FormSelectMultiple.prototype.checkOutsideClick = function (event, select) {
        if (!event.composedPath().includes(select)) {
            this.closeOptionList(select);
        }
    };
    /**
     * Delete selected elements and make ajax call
     * @private
     */
    FormSelectMultiple.prototype.clearAllOptions = function () {
        var _this = this;
        var selectOptions = document.querySelectorAll("[".concat(constants_1.DATA_FORM_SELECT_MULTIPLE_OPTION, "]"));
        var _loop_1 = function (i) {
            this_1.selectArrays[i] = [];
            selectOptions.forEach(function (option) {
                var input = option.querySelector('.form-check');
                if (input.checked) {
                    input.checked = false;
                    _this.removeSelectedOption(input.value, option.parentElement.previousElementSibling, _this.selectArrays[i]);
                }
            });
        };
        var this_1 = this;
        for (var i = 0; i < this.selectArrays.length; i++) {
            _loop_1(i);
        }
    };
    return FormSelectMultiple;
}(AbstractComponent_1.default));
exports.default = FormSelectMultiple;
